import { projectsAPINEW } from './../../api/projects-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { setAppErrorAC, setAppStatusAC } from '../../app/app-reducer';
import { AppRootState } from '../../app/store';
import { handleRequestResponseError, handleServerNetworkError } from '../../utils/errorUtils/handleServerNetworkError';
import { setIsNewTask } from '../TasksList/tasks-reducer';
import { clearAttachmentState } from './newTaskAttachments-reducer';

export type NewTaskType = {
  id: number
  title: string
  status: string
  priority: number
  systemInfo: string
}

export type NewTaskStateType = {
  taskData: NewTaskType
  openedTab: string
  projectName: string
}
const initialStateNewTask = {
  taskData: {
    id: 1,
    title: '',
    status: 'New',
    priority: 2,
    systemInfo: '',
  },
  openedTab: 'details',
  projectName: ''
}

export const addPictureToSystemInfoTC = createAsyncThunk('addPictureToSystemInfo/newTask', async (params: {
  imgSrc: string, projectId: number, projectName: string, fileName: string,formData: any}, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    const res = await projectsAPINEW.createAttachment(token, params.projectId, params.projectName, params.fileName, params.formData)
    const id = res.data[0].id

    const state = thunkAPI.getState() as AppRootState
    let text = state.newTask.taskData.systemInfo
    let newText = text + `<img alt=${params.fileName} src=${params.imgSrc} data-src=${res.data[0].url} />`

    thunkAPI.dispatch(setNewTaskSystemInfoAC({ systemInfo: newText }))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue(null)
  }
})

export const createNewTaskTC = createAsyncThunk('createNewTask/newTask', async (params: {projectName: string, projectId: number
}, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    const state = thunkAPI.getState() as AppRootState
    const newTask = state.newTask
    const attachedFiles = state.newTaskAttachments.relations
    const attachments = attachedFiles.map(item => {
      const container = {attachmentUrl: ''}
    container.attachmentUrl = item.url
    return container
    })

    let description = newTask.taskData.systemInfo
    if(!description) {
      description=''
    }
    let parser = new DOMParser()
    let html = parser.parseFromString(description, 'text/html')
    let arr = html.getElementsByTagName("img")
    for(let i=0; i< arr.length; i++){
      let serverSrc= arr[i].dataset.src
      if(serverSrc)
      arr[i].src = serverSrc
      arr[i].removeAttribute('data-src')
    }
    let newDescription =  new XMLSerializer().serializeToString(html)
    const res = await projectsAPINEW.createNewTask(token, params.projectId , newTask.taskData.title,
       newTask.taskData.priority, newDescription , attachments)
    console.log('newTaskResponse',  res)
    const newTaskId  = res.data.id
    thunkAPI.dispatch(setIsNewTask({isNewTask: false}))
    thunkAPI.dispatch(clearNewTask({title: ''}))
    thunkAPI.dispatch(clearAttachmentState())
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    thunkAPI.dispatch(setAppErrorAC({error: `New Work Item #${newTaskId} ${newTask.taskData.title} was created!`, color:'success'}))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue(null)
  }
})

const slice = createSlice({
  name: 'workItems',
  initialState: initialStateNewTask,
  reducers: {
    setProjectName(state, action: PayloadAction<{ name: string }>) {
      state.projectName = action.payload.name
    },
    setNewTaskTitle(state, action: PayloadAction<{ title: string }>) {
      state.taskData.title = action.payload.title
    },
    setTabNewTask(state, action: PayloadAction<{ tabName: string }>) {
      if (action.payload) {
        state.openedTab = action.payload.tabName }
    },
    setNewTaskSystemInfoAC(state, action: PayloadAction<{ systemInfo: string }>) {
      state.taskData.systemInfo = action.payload.systemInfo
    },
    setPriorityAC(state, action: PayloadAction<{ value: number }>) {
      state.taskData.priority = action.payload.value
    },
    clearNewTask(state, action: PayloadAction<{title: string}>) {
      state.openedTab='details'
      state.projectName = ''
      state.taskData.title = action.payload.title
      state.taskData.id = 1
      state.taskData.status = 'New'
      state.taskData.priority = 2
      state.taskData.systemInfo = ''
      
    }
  }
})
export const newTaskReducer = slice.reducer
export const { setProjectName, setNewTaskSystemInfoAC, setNewTaskTitle, setTabNewTask, setPriorityAC, clearNewTask } = slice.actions
